import React from "react";
import PriceChopperPageFooter from "./PriceChopperPageFooter";
import PriceChopperPageModel from "./PriceChopperPageModel";
import ProductListing from "../ProductListing";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";

const PriceChopperPage = ({
  featureFlags,
  facetNavigation,
  pageName,
  pageUrl,
  pagination,
  products,
  showSeoText,
}: PriceChopperPageModel) => {
  return (
    <FeatureFlagProvider featureFlags={featureFlags}>
      <ProductListing
        aboveChromeComponent={
          showSeoText ? (
            <>
              <div className="page-header-container">
                {pageName && (
                  <h1 className="page-header" data-catid="0">
                    {pageName}
                  </h1>
                )}
                <h2 className="page-header-2">
                  {" "}
                  Discounted Commercial Restaurant Equipment, Supplies, & More
                </h2>
              </div>
              <div className="page-header-content" />
            </>
          ) : undefined
        }
        belowPageComponent={
          showSeoText ? <PriceChopperPageFooter /> : undefined
        }
        facetNavigation={facetNavigation}
        hasBackground={false}
        hasHeaderData={false}
        hideFilters={false}
        pageName={pageName}
        pageUrl={pageUrl}
        pagination={pagination}
        products={products}
        showSearchWithinFilter={false}
      />
    </FeatureFlagProvider>
  );
};

export default PriceChopperPage;
